import { Link } from "react-router-dom";
import type { EditorialArticleCard } from "../../types/insights";

export default function EditorialArticleCards({
  articles,
  heading = "Related guides",
  id,
}: {
  articles: EditorialArticleCard[];
  heading?: string;
  id?: string;
}) {
  if (!articles.length) return null;

  return (
    <section aria-labelledby={id} className="mt-12 border-t border-slate-200 pt-8">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[.18em] text-[#0d7078]">Premier Pharma Insights</p>
          <h2 id={id} className="mt-2 text-2xl font-bold text-slate-900">{heading}</h2>
        </div>
        <Link to="/insights" className="text-sm font-semibold text-[#0d7078] underline underline-offset-4 hover:text-[#0a5960]">
          Browse all insights
        </Link>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <article key={article.id} className="flex min-w-0 flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-[#9ccfd0] hover:shadow-md">
            <p className="text-xs font-bold uppercase tracking-wider text-[#0d7078]">{article.category}</p>
            <h3 className="mt-2 text-lg font-bold leading-snug text-slate-900">
              <Link to={`/insights/${article.slug}`} className="hover:text-[#0d7078] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0d7078]">
                {article.title}
              </Link>
            </h3>
            <p className="mt-2 line-clamp-3 text-sm leading-6 text-slate-600">{article.excerpt}</p>
            <div className="mt-auto flex items-center justify-between gap-3 pt-5 text-xs text-slate-500">
              {article.publishedAt
                ? <time dateTime={article.publishedAt}>{new Date(article.publishedAt).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</time>
                : <span>Premier Pharma Insights</span>}
              <span aria-hidden="true" className="text-base text-[#0d7078]">→</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
